import { useState } from "react";
import { BaseButton, BaseInput } from "../../components/base";
import { useNotification } from "../../context/NotificationProvider";
import { Box, Typography, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/hashinLogoLight.png";
import URIs from "../../utils/uri";
import { sendKyc } from "../../api/auth/authAPI";
import useProtectedClient from "../../hooks/useProtectedClient";
import { formatDateToString } from "../../utils/helpers";

const Kyc = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [nationalId, setNationalId] = useState("");
    const [birthDate, setBirthDate] = useState({
        day: "11",
        month: "8",
        year: "1370",
    });
    const { showNotification } = useNotification();
    const protectedClient = useProtectedClient();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (nationalId.length !== 10) {
            showNotification("کد ملی باید دقیقا ۱۰ رقم باشد.", "error");
            return;
        }
        if (!birthDate.day || !birthDate.month || !birthDate.year) {
            showNotification("لطفاً تاریخ تولد کامل را وارد کنید.", "error");
            return;
        }

        setIsLoading(true);
        try {
            const birthDateStr = formatDateToString(birthDate)
            await sendKyc(protectedClient, nationalId, birthDateStr)
            navigate(URIs.HOME);
        } catch (error) {
            showNotification(error, "error");
        } finally {
            setIsLoading(false);
        }
    };

    const handleIdChange = (e) => {
        const value = e.target.value;
        // Allow only numbers and restrict to 10 characters
        if (/^\d*$/.test(value) && value.length <= 10) {
            setNationalId(value);
        }
    };

    const handleBirthDateChange = (e) => {
        const { name, value } = e.target;
        setBirthDate((prevDate) => ({
            ...prevDate,
            [name]: value,
        }));
    };

    const generateOptions = (start, end) => {
        const options = [];
        for (let i = start; i <= end; i++) {
            options.push(i);
        }
        return options;
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            padding={2}
            gap={4}
            sx={{ height: "100vh", paddingTop: "80px" }}
        >
            <img src={logo} alt="Logo" style={{ width: "120px" }} />
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2}>
                <Typography variant="caption" sx={{ textAlign: "center", width: "90%", maxWidth: 400 }}>
                    احراز هویت
                </Typography>
                <Typography variant="subtitle" sx={{ textAlign: "center", width: "90%", maxWidth: 400 }}>
                    جهت شروع معامله لازم است، کد ملی و تاریخ تولد خود را وارد کنید تا با کد ملی مالک شماره موبایلتان به صورت خودکار تطابق دهیم.
                </Typography>
            </Box>
            <form onSubmit={handleSubmit} style={{ width: "90%", maxWidth: 400 }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="stretch"
                    gap={2}
                >
                    <BaseInput
                        label="کد ملی"
                        value={nationalId}
                        onChange={handleIdChange}
                        name="nationalId"
                        type="number"
                    />

                    <Typography variant="subtitle" sx={{ textAlign: "left", width: "100%" }}>
                        تاریخ تولد
                    </Typography>

                    <Box display="flex" justifyContent="space-between" gap={2}>
                        
                        <FormControl fullWidth>
                            <InputLabel>روز</InputLabel>
                            <Select
                                name="day"
                                value={birthDate.day}
                                onChange={handleBirthDateChange}
                                label="روز"
                            >
                                {generateOptions(1, 31).map((day) => (
                                    <MenuItem key={day} value={day}>
                                        {day}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* Month Select */}
                        <FormControl fullWidth>
                            <InputLabel>ماه</InputLabel>
                            <Select
                                name="month"
                                value={birthDate.month}
                                onChange={handleBirthDateChange}
                                label="ماه"
                            >
                                {generateOptions(1, 12).map((month) => (
                                    <MenuItem key={month} value={month}>
                                        {month}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* Year Select */}
                        <FormControl fullWidth>
                            <InputLabel>سال</InputLabel>
                            <Select
                                name="year"
                                value={birthDate.year}
                                onChange={handleBirthDateChange}
                                label="سال"
                            >
                                {generateOptions(1320, 1420).map((year) => (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    <BaseButton type="submit" isLoading={isLoading}>
                        تایید
                    </BaseButton>
                </Box>
            </form>
        </Box>
    );
};

export default Kyc;
